// API
import BookingAPI from 'api/bookings'
// UTILS
import { Utils } from 'utils/Utils'
// ACTIONS
import _ from 'lodash'
// CONSTANT
import {
  FULL_DAY,
  LONG_HAUL
} from 'constants/bookingConstants'
import {
  EXTRA_REQUIREMENT_VEHICLE_TYPE_BY_OPTIONS
} from 'constants/extraServiceConstants'
import { isEditBooking, isMarketingPage } from 'utils/booking/common'
import { updateLocation } from './locationActionCreators'

import { extraServicesActionsCreator } from 'store/toolkit/extraServices/extraServices.reducer'



const receiveExtraServices = (extraServices, timeType) => extraServicesActionsCreator.receiveExtraServices({
  extraServices,
  timeType
})

export const updateExtraServicesTimeType = timeType => extraServicesActionsCreator.updateExtraServicesTimeType(timeType)

export const setPreVehicleTypeId = preVehicleTypeId => extraServicesActionsCreator.setPreVehicleTypeId(preVehicleTypeId)

export const updateExtraRequirement = (id, attrs) => extraServicesActionsCreator.updateExtraRequirement({
  id,
  attrs
})

export const updateSelectedExtraRequirementForPerLocation = extraRequirement => extraServicesActionsCreator.updateSelectedExtraRequirementForPerLocation(extraRequirement)

export const updateExtraRequirementNegativePosition = (id, attrs) => extraServicesActionsCreator.updateExtraRequirementNegativePosition({
  id,
  attrs
})

export const updateFullDayPricing = attrs => dispatch => dispatch(extraServicesActionsCreator.updateFullDayPricing(attrs))

export const updateBadge = (id, attrs) => dispatch => dispatch(extraServicesActionsCreator.updateBadge({
  id,
  attrs
}))

export const updateCompanyBadge = (id, attrs) => dispatch => dispatch(extraServicesActionsCreator.updateCompanyBadge({
  id,
  attrs
}))

export const updateCompanySetting = attrs => dispatch => dispatch(extraServicesActionsCreator.updateCompanySetting(attrs))

export const clearVehicleTypeSettings = () => dispatch => dispatch(extraServicesActionsCreator.clearVehicleTypeSettings())

export const updateCustomReimbursement = (id, attrs) => dispatch => dispatch(extraServicesActionsCreator.updateCustomReimbursement({
  id,
  attrs
}))

/**
 * I think a better approach for  the edit booking flow as below
 *  - copy all data from bookAgainDetails to booking and treat edit booking as normal booking,
 *  - identify what is actual different between edit booking and booking
 *      and write specific logic to handle some exception case such as stage or temp data
 */
 export const setUpBookAgainFullDay = () => (dispatch, getState) => {
  if (getState().timeType === FULL_DAY) {
    const bookingDetails = getState().bookAgainDetails
    const extraInfos = getState().extraInfos
    const extraRequirementsNegativePosition = getState().extraServices.extraRequirementsNegativePosition
    if (!_.isEmpty(bookingDetails) && !extraInfos.new_booking) {
      extraRequirementsNegativePosition.forEach((extra) => {
        const oldExtra = _.find(
          bookingDetails.booking_extra_requirements_negative_position,
          { extra_requirement_id: extra.id }
        )
        if (_.isEmpty(oldExtra)) {
          dispatch(updateExtraRequirementNegativePosition(extra.id, { selected: false, selected_amount: 0 }))
        } else if (extra.pricing_method === EXTRA_REQUIREMENT_VEHICLE_TYPE_BY_OPTIONS) {
          const pricing = _.find(
            extra.pricings, { id: oldExtra.extra_requirement_pricing_id }
          )
          dispatch(updateExtraRequirementNegativePosition(extra.id, {
            selectedPricing: pricing, selected: true, selected_amount: oldExtra.selected_amount
          }))
        } else {
          dispatch(updateExtraRequirementNegativePosition(
            extra.id,
            { selected: true, selected_amount: oldExtra.selected_amount }
          ))
        }
      })
    }
  }
}

export const setUpBookAgainBadges = () => (dispatch, getState) => {
  const bookingDetails = getState().bookAgainDetails
  const vehicleTypeBadges = getState().extraServices.vehicleTypeBadges
  const companyBadges = getState().extraServices.companyBadges
  const extraInfos = getState().extraInfos
  if (!_.isEmpty(bookingDetails) && !extraInfos.new_booking && !isMarketingPage) {
    vehicleTypeBadges.forEach((badge) => {
      const badgeBookingDetails = _.find(bookingDetails.booking_badges,
        { badgeable_relation_id: badge.id, badgeable_relation_type: 'VehicleTypeBadge' })
      if (!_.isEmpty(badgeBookingDetails)) {
        dispatch(updateBadge(badge.id, { selected: true, selected_amount: badgeBookingDetails.selected_amount }))
      }
    })
    companyBadges.forEach((badge) => {
      const badgeBookingDetails = _.find(bookingDetails.booking_badges,
        { badgeable_relation_id: badge.id, badgeable_relation_type: 'CompanyBadge' })
      if (!_.isEmpty(badgeBookingDetails)) {
        dispatch(updateCompanyBadge(badge.id, { selected: true, selected_amount: badgeBookingDetails.selected_amount }))
      } else if (badge.badgeable_relation_type === 'CompanyBadge') {
        dispatch(updateCompanyBadge(badge.id, { selected: false, selected_amount: badge.selected_amount }))
      }
    })
  }
}

export const setUpBookAgainFullDayPricing = () => (dispatch, getState) => {
  const extraInfos = getState().extraInfos || {}
  const bookingDetails = getState().bookAgainDetails
  const needToFillWithBookingDetail = !_.isEmpty(bookingDetails)
    && bookingDetails.full_day_selected_amount
    && !extraInfos.new_booking
  if (needToFillWithBookingDetail) {
    dispatch(updateFullDayPricing({
      selected: (bookingDetails.full_day_selected_amount >= 0),
      selected_amount: parseInt(bookingDetails.full_day_selected_amount, 10)
    }))
  }
}

const setUpBookAgainForExtraRequirementPerLocation = () => (dispatch, getState) => {
  const {
    bookAgainDetails, extraServices, locations
  } = getState()
  const extraRequirements = extraServices.extraRequirements
  const bookAgainLocations = bookAgainDetails.locations
  const extraRequirementIds = _.map(extraRequirements, 'id')
  locations.forEach((location, index) => {
    let data = []
    if (!_.isEmpty(bookAgainLocations) && bookAgainLocations[index]
      && !_.isEmpty(bookAgainLocations[index].extra_requirement_locations)) {
      if (_.includes(extraRequirementIds,
        bookAgainLocations[index].extra_requirement_locations[0].extra_requirement_id)) {
        data = bookAgainLocations[index].extra_requirement_locations
      }
    }
    dispatch(updateLocation(
      location.id, { extra_requirement_locations: data }
    ))
  })
}

const setUpForExtraRequirementPerLocation = () => (dispatch, getState) => {
  const {
    extraServices, locations
  } = getState()
  const extraRequirements = extraServices.extraRequirements
  const extraRequirementIds = _.map(extraRequirements, 'id')
  locations.forEach((location) => {
    let data = []
    if (!_.isEmpty(location.extra_requirement_locations)
      && _.includes(extraRequirementIds, location.extra_requirement_locations[0].extra_requirement_id)) {
      data = location.extra_requirement_locations
    } else {
      extraRequirements.forEach((extraRequirement) => {
        const checkByDefault = extraRequirement.check_by_default
        const selectedAmount = checkByDefault ? 1 : extraRequirement.selected_amount
        if (extraRequirement.is_flat_per_location) {
          data.push({
            extra_requirement_id: extraRequirement.id,
            is_flat_per_location: extraRequirement.is_flat_per_location,
            name: extraRequirement.name,
            position: extraRequirement.position,
            selected_amount: selectedAmount,
            unit_price: extraRequirement.unit_price
          })
        }
      })
    }
    dispatch(updateLocation(
      location.id, { extra_requirement_locations: data }
    ))
  })
}

export const setUpBookingLocationForExtraRequirementPerLocation = () => (dispatch, getState) => {
  const {
    bookAgainDetails, extraServices, locations, timeType
  } = getState()
  const extraRequirements = extraServices.extraRequirements
  if (timeType !== LONG_HAUL) {
    _.forEach(locations, (location) => {
      dispatch(updateLocation(
        location.id, { extra_requirement_locations: [] }
      ))
    })
  } else if (!_.isEmpty(extraRequirements)) {
    if (!_.isEmpty(bookAgainDetails) && !isMarketingPage) {
      dispatch(setUpBookAgainForExtraRequirementPerLocation())
    } else {
      dispatch(setUpForExtraRequirementPerLocation())
    }
  }
}

// setup reimbursement for edit booking and booking again
export const setUpBookAgainReimbursement = (
  preExtraServices,
  isVehicleTypeChanged,
  isTimeTypeChanged
) => (dispatch, getState) => {
  const preVehicleTypeSettings = _.get(preExtraServices, 'vehicleTypeSettings')
  const bookingDetails = getState().bookAgainDetails
  const vehicleTypeSettings = _.get(getState(), 'extraServices.vehicleTypeSettings')
  const isEditOrBookAgain = !_.isEmpty(bookingDetails) && bookingDetails.allow_tolls_fees !== '' && !isMarketingPage
  if (
    isEditOrBookAgain
      && _.isEmpty(preVehicleTypeSettings) // only run once (init)
      && !_.isEmpty(vehicleTypeSettings)
      && !isVehicleTypeChanged
      && !isTimeTypeChanged
  ) {
    dispatch(updateCompanySetting({
      allow_tolls_fees: bookingDetails.allow_tolls_fees,
      allow_parking_fees: bookingDetails.allow_parking_fees,
      allow_waiting_time_fees: bookingDetails.allow_waiting_time_fees,
    }))
  }
}

export const setUpBadgesForEdit = () => (dispatch, getState) => {
  if (isEditBooking()) {
    const bookingDetails = getState().bookAgainDetails
    const extraInfos = getState().extraInfos
    if (!_.isEmpty(bookingDetails) && !extraInfos.new_booking && !isMarketingPage) {
      bookingDetails.booking_badges.forEach((badge) => {
        if (badge.badgeable_relation_type === 'VehicleTypeBadge') {
          dispatch(updateBadge(parseInt(badge.badgeable_relation_id, 10), {
            selected: true,
            selected_amount: badge.selected_amount
          }))
        } else {
          dispatch(updateCompanyBadge(parseInt(badge.badgeable_relation_id, 10), {
            selected: true,
            selected_amount: badge.selected_amount
          }))
        }
      })
    }
  }
}

// setup custom reimbursement for edit booking and booking again
export const setUpBookAgainCustomReimbursement = (
  preExtraServices,
  isVehicleTypeChanged,
  isTimeTypeChanged
) => (dispatch, getState) => {
  const bookAgainDetails = _.get(getState(), 'bookAgainDetails')

  const customReimbursementsOfBookAgain = _.get(getState(), 'bookAgainDetails.custom_reimbursements')
  const customReimbursements = _.get(getState(), 'extraServices.customReimbursements')
  const isFirstGetExtraService = !preExtraServices.isGetExtraService
  const isEditOrBookAgain = !_.isEmpty(bookAgainDetails) && !isMarketingPage
  if (
    isEditOrBookAgain
    && isFirstGetExtraService // only run once (init)
    && !_.isEmpty(customReimbursements) // have the custom reimbursement
    && !isVehicleTypeChanged
    && !isTimeTypeChanged
  ) {
    customReimbursements.forEach((reimbursement) => {
      const reimbursementOfBookAgain = customReimbursementsOfBookAgain.find(
        item => item.vehicle_type_reimbursement_id === reimbursement.id
      )

      const validReimbursement = !_.isEmpty(reimbursementOfBookAgain)
      const { oldSelectedAmount, oldUserInputAmount } = Utils.buildCustomReimbursementsOfBookAgain(
        customReimbursementsOfBookAgain,
        reimbursementOfBookAgain,
        reimbursement,
        validReimbursement
      )

      dispatch(updateCustomReimbursement(
        reimbursement.id,
        {
          ...(reimbursement.allow_user_to_enter_amount ? { user_input_amount: oldUserInputAmount } : {}),
          selected_amount: oldSelectedAmount
        }
      ))
    })
  }
}

export const getExtraServices = callback => (dispatch, getState) => {
  const {
    currentCustomer, timeType, selectedServiceTypeID,
    selectedVehicleTypeID, locations, isLoginStep3,
    bookAgainDetails, extraServices
  } = getState()
  const validLocations = _.filter(locations, l => !_.isUndefined(l.lat) || !_.isUndefined(l.lng))
  const preExtraRequirements = getState().extraServices.extraRequirements
  const isVehicleTypeChanged = extraServices.preVehicleTypeId !== selectedVehicleTypeID
  const isTimeTypeChanged = extraServices.timeTypeOfExtraServices !== timeType
  if (isVehicleTypeChanged) {
    dispatch(setPreVehicleTypeId(selectedVehicleTypeID))
  }

  if (isTimeTypeChanged) {
    dispatch(updateExtraServicesTimeType(timeType))
  }

  BookingAPI.getExtraServices(
    currentCustomer.authentication_token,
    currentCustomer.current_company_id,
    timeType,
    selectedServiceTypeID,
    selectedVehicleTypeID,
    validLocations.length,
    (results) => {
      const newResult = {
        ...results,
        preExtraRequirements,
        preExtraServices: extraServices,
        isLoginStep3,
        bookingDetails: bookAgainDetails,
        isVehicleTypeChanged,
        isTimeTypeChanged
      }

      Promise.resolve(
        dispatch(receiveExtraServices(newResult, timeType)),
      ).then(() => (
        Promise.all([
          dispatch(setUpBookAgainCustomReimbursement(extraServices, isVehicleTypeChanged, isTimeTypeChanged)),
          dispatch(setUpBookAgainFullDay()),
          dispatch(setUpBookAgainBadges()),
          dispatch(setUpBookAgainFullDayPricing()),
          dispatch(setUpBookingLocationForExtraRequirementPerLocation()),
          dispatch(setUpBadgesForEdit()),
          dispatch(setUpBookAgainReimbursement(extraServices, isVehicleTypeChanged, isTimeTypeChanged)),
        ])
      )).then(() => (
        callback()
      ))
    }
  )
}
